import {
    makeStyles,
} from 'app/tss'
import {
    WarningCardVariant,
} from 'app/enums/common.enums'

const useStyles = makeStyles()((theme) => {
    return {
        container: {
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(1),
            borderRadius: 8,
            fontSize: theme.typography.body1.fontSize,
            padding: theme.spacing(1, 1),
            marginBottom: theme.spacing(1),
        },
        text: {
            alignSelf: 'center',
        },
        [WarningCardVariant.Warning]: {
            background: theme.palette.common.beige,
        },
        [WarningCardVariant.Error]: {
            background: theme.palette.warning.light,
        },
        [WarningCardVariant.Critical]: {
            background: theme.palette.warning.main,
            color: theme.palette.common.red,
            fontSize: theme.typography.h3.fontSize,
            alignItems: 'flex-start',
            padding: theme.spacing(0.5, 1),
        },
    }
})

export default useStyles
